import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmpresaResponse } from "../types/empresa";
import { RootState } from "./store";

type CurrentEmpresaState = {
    generalInfo: EmpresaResponse | null;
}

const initialState: CurrentEmpresaState = { generalInfo: null };

export const empresaSelectedSlice = createSlice({
    name: "empresaSelected",
    initialState,
    reducers: {
        setGeneralInfo: (state, action: PayloadAction<EmpresaResponse | undefined>) => {
            if(action.payload == undefined) return;

            state.generalInfo = action.payload;
        }
    }
})

export default empresaSelectedSlice.reducer;
export const selectGeneralInfo = (state: RootState) => state.empresaSelected.generalInfo;
export const {
    setGeneralInfo,
} = empresaSelectedSlice.actions;